import React, { useEffect, useState } from "react";
import { Divider, Stack, Typography } from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import { HubCardStack, HubHookFormWrapper } from "../../components";
import { useGetLaborData, usePutUpdateLabor } from "../../hooks";
import LaborDetails from "./LaborDetails";
import LaborFields from "./LaborFields";
import LaborButtonBar from "./LaborButtonBar";
import LaborType from "./LaborType";

const LaborDetailsContent = () => {
  const [nav, setNav] = useState(false);

  const { id } = useParams();
  const { data, isLoading: isLoadingGet, refetch } = useGetLaborData(id);
  const {
    mutate: putUpdateLabor,
    isLoading: isLoadingPut,
    isSuccess,
  } = usePutUpdateLabor();

  const navigate = useNavigate();

  useEffect(() => {
    if (isSuccess) {
      nav ? navigate("/displays") : refetch();
    }
  }, [isSuccess]);

  const isLoading = isLoadingGet || isLoadingPut;

  const handleSubmit = (formData, event) => {
    const buttonId = event.nativeEvent.submitter.id;
    const payload = {
      id,
      scrapped: formData.scrapped,
      completed: formData.completed,
      ...(formData?.heatCode ? { heatCode: String(formData.heatCode) } : {}),
      ...(formData?.sampleWeight
        ? { sampleWeight: Number(formData.sampleWeight) }
        : {}),
      laborMaterials: formData?.laborMaterials
        ? formData?.laborMaterials?.map(({ materialId, quantity }) => ({
            materialId: Number(materialId),
            quantity: Number(quantity),
          }))
        : [],
    };

    switch (buttonId) {
      case "save":
        putUpdateLabor(payload);
        break;
      case "submit":
        setNav(true);
        payload.isClose = true;
        putUpdateLabor(payload);
        break;
      default:
        break;
    }
  };

  const props = {
    laborId: id,
    station: data?.station,
    scrapped: data?.scrapped,
    completed: data?.completed,
    heatCode: data?.heatCode,
    quantity: data?.workOrder?.quantity,
    available: data?.available,
  };

  const allowChildRoutes = !!data?.station?.allowChildRoutes;
  const isSubRoute = data?.routing?.isSubRoute;
  const isPartial = data?.isPartial;
  const allowRework = allowChildRoutes && !isSubRoute;

  return (
    <HubCardStack
      margin="25px"
      overflow="hidden"
      flexGrow="0 !important"
      maxWidth="1000px"
      width="100%"
      isLoading={isLoading}
    >
      <HubHookFormWrapper onSubmit={handleSubmit}>
        <Stack gap="25px" justifyContent="center" alignItems="center">
          {(isSubRoute || isPartial) && <LaborType isSubRoute={isSubRoute} />}
          <Stack gap="5px" width="100%" alignItems="start">
            <Typography variant="boldCaption">Labor Ticket #{id}</Typography>
            <Typography variant="caption">
              Add details such as scrap, complete, and heat code for labor run
            </Typography>
          </Stack>
          <LaborDetails data={data} />
          <Divider orientation="horizontal" flexItem />
          <LaborFields {...props} key={JSON.stringify(props)} />
          <LaborButtonBar
            allowRework={allowRework}
            workOrder={data?.workOrder?.workOrder}
          />
        </Stack>
      </HubHookFormWrapper>
    </HubCardStack>
  );
};

export default LaborDetailsContent;
